export default class Option {
  static hySplitTypes = [{
    value: 1,
    label: '后向轨迹'
  }, {
    value: 3,
    label: '聚类轨迹'
  }]

  static durations = [{
    value: 24,
    label: '24小时'
  }, {
    value: 48,
    label: '48小时'
  }, {
    value: 72,
    label: '72小时'
  }]

  static heights = [{
    value: 100,
    label: '100米'
  }, {
    value: 500,
    label: '500米'
  }, {
    value: 1000,
    label: '1000米'
  }]

  static monthsMap = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
}



// WEBPACK FOOTER //
// ./src/views/04Statistical-Analysis/03Pollution/04HYSPLIT/Option.js